module.exports = __webpack_public_path__ + "static/media/welcome-3.3c7fd287.jpg";